import { List } from '@chakra-ui/react';
import type { ReactElement, ReactNode } from 'react';
import VAlert from './VAlert.jsx';
import VMaterialIcon from './icons/VMaterialIcon.jsx';

type VFormErrorSummaryProps = {
  title?: ReactNode;
  errors: string[];
};

const VFormErrorSummary = ({ title, errors }: VFormErrorSummaryProps): ReactElement | null => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <VAlert
      status="error"
      icon={<VMaterialIcon name="warning" />}
      title={title}
      description={
        <List.Root listStylePosition="inside">
          {errors.map((error) => (
            <List.Item key={error} _marker={{ color: 'inherit' }}>
              {error}
            </List.Item>
          ))}
        </List.Root>
      }
    />
  );
};

export default VFormErrorSummary;
